import { Datepicker } from 'vanillajs-datepicker';
import de from 'vanillajs-datepicker/locales/de';

Object.assign(Datepicker.locales, de);

/**
 * @param {HTMLElement} element
 */
function findCalendarButton(element) {
  if (element == null) {
    return null;
  }

  const sibling = element.nextElementSibling;
  if (sibling == null) {
    return null;
  }

  if (sibling.tagName === 'BUTTON') {
    return sibling;
  }

  return findCalendarButton(sibling);
}

function initializeDatepicker(element) {
  const datepicker = new Datepicker(element, {
    buttonClass: 'btn',
    autohide: true,
    format: 'dd.mm.yyyy',
    orientation: 'auto middle',
    language: 'de',
  });

  element.addEventListener('show', (event) => {
    event.preventDefault();
  });

  const button = findCalendarButton(element);
  if (button) {
    button.addEventListener('click', (event) => {
      event.preventDefault();

      let datepickerPrevBtn = document.querySelectorAll('.datepicker-controls .prev-btn');
      let datepickerNextBtn = document.querySelectorAll('.datepicker-controls .next-btn');

      for (let item of datepickerPrevBtn) {
        item.innerHTML = '<span class="fa fa-angle-left">';
      }

      for (let item of datepickerNextBtn) {
        item.innerHTML = '<span class="fa fa-angle-right">';
      }

      datepicker.show();
    });
  }
}

function handleMutations(mutationsList) {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof HTMLElement) {
          if (node.matches('input[type=text].form-datepicker')) {
            initializeDatepicker(node);
          } else {
            const nestedInputs = node.querySelectorAll('input[type=text].form-datepicker');
            nestedInputs.forEach((nestedInput) => {
              initializeDatepicker(nestedInput);

            });
          }
        }
      });
    }
  }
}

const observer = new MutationObserver(handleMutations);

observer.observe(document.documentElement, { childList: true, subtree: true });

function init() {
  const existingInputs = document.querySelectorAll('input[type=text].form-datepicker');
  existingInputs.forEach((input) => {
    initializeDatepicker(input);
  });
}

export default {
  init
};
